import { render, staticRenderFns } from "./AssessmentResultLoading.vue?vue&type=template&id=34d4f584&scoped=true"
import script from "./AssessmentResultLoading.vue?vue&type=script&lang=ts"
export * from "./AssessmentResultLoading.vue?vue&type=script&lang=ts"
import style0 from "./AssessmentResultLoading.vue?vue&type=style&index=0&id=34d4f584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d4f584",
  null
  
)

export default component.exports